module.exports = __webpack_public_path__ + "img/visa-application.46c34f41.svg";